import * as Yup from 'yup';

export const populationSchema = Yup.object({
  populations: Yup.array(
    Yup.object({
      cycle: Yup.number().required('Campo Obrigatório'),
      lot: Yup.string().required('Campo Obrigatório'),
      date: Yup.date().required('Campo Obrigatório').typeError('Data inválida'),
      quantity: Yup.string().required('Campo Obrigatório'),
      size_remain: Yup.number(), // Se não for obrigatório, pode deixar assim
    })
  ).min(1, 'Adicione pelo menos uma população'),
});
